import Twitter from '../../assets/icons/twitter.svg';
import Instagram from '../../assets/icons/instagram.svg';
import Facebook from '../../assets/icons/facebook.svg';
import Youtube from '../../assets/icons/youtube.svg';
import AppStore from '../../assets/icons/app_store.svg';
import GooglePlay from '../../assets/icons/google_play.svg';
import ZonaLandingImgLOGO from '../../assets/img/logo24MX.svg';

const MXDataFooter = {
  footerLinks: [
    {
      title: 'Más Inmuebles24',
      content: [
        {
          controlPanel: 'inmuebles-argentina',
          wording: 'Inmuebles en México',
          link: 'https://www.inmuebles24.com/inmuebles.html'
        },
        {
          controlPanel: 'publica',
          wording: 'Publicar tu Inmueble',
          link: 'https://www.inmuebles24.com/publica-tu-propiedad'
        },
        {
          controlPanel: 'ayuda',
          wording: 'Ayuda',
          link: 'https://help.inmuebles24.com/s/'
        },
        {
          controlPanel: 'mapa-sitio',
          wording: 'Mapa del sitio',
          link: 'https://www.inmuebles24.com/sitemaps/'
        },
        {
          controlPanel: 'publicidad',
          wording: 'Publicidad',
          link: 'http://www.naventmedia.com/'
        },
        {
          controlPanel: 'noticias',
          wording: 'Noticias',
          link: 'https://www.inmuebles24.com/noticias/'
        },
        {
          controlPanel: 'valuador',
          wording: '¿Cuánto vale?',
          link: 'https://www.inmuebles24.com/cuantovale'
        },
        {
          controlPanel: 'garantias-alquiler',
          wording: 'Noticias para agentes inmobiliarios',
          link: 'https://www.inmuebles24.com/noticias/tag/b2b/'
        }
      ]
    },
    {
      title: 'Anunciantes',
      content: [
        {
          controlPanel: 'inmobiliarias',
          wording: 'Inmobiliarias',
          link: 'https://www.inmuebles24.com/inmobiliarias.bum'
        },
        {
          controlPanel: 'corredores',
          wording: 'Corredores',
          link: 'https://www.inmuebles24.com/corredores.bum'
        },
        {
          controlPanel: 'constructoras',
          wording: 'Constructoras',
          link: 'https://www.inmuebles24.com/constructoras.bum'
        }
      ]
    },
    {
      title: 'Países',
      content: [
        {
          controlPanel: 'argentina',
          wording: 'Argentina',
          options: [
            {
              wording: 'Zonaprop',
              link: 'https://www.zonaprop.com.ar/'
            }
          ]
        },
        {
          controlPanel: 'brasil',
          wording: 'Brasil',
          options: [
            {
              wording: 'Imovelweb',
              link: 'https://www.imovelweb.com.br'
            },
            {
              wording: 'Wimoveis',
              link: 'https://www.wimoveis.com.br'
            },
            {
              wording: 'CasaMineira',
              link: 'https://www.casamineira.com.br'
            },
            {
              wording: 'QuintoAndar',
              link: 'https://www.quintoandar.com.br/ '
            }
          ]
        },
        {
          controlPanel: 'ecuador',
          wording: 'Ecuador',
          options: [
            {
              wording: 'Plusvalia',
              link: 'https://www.plusvalia.com'
            }
          ]
        },
        {
          controlPanel: 'mexico',
          wording: 'México',
          options: [
            {
              wording: 'Vivanuncios',
              link: 'https://www.vivanuncios.com.mx'
            }
          ]
        },
        {
          controlPanel: 'panama',
          wording: 'Panamá',
          options: [
            {
              wording: 'Compreoalquile',
              link: 'https://www.compreoalquile.com'
            }
          ]
        },
        {
          controlPanel: 'peru',
          wording: 'Perú',
          options: [
            {
              wording: 'Urbania',
              link: 'https://www.urbania.pe'
            },
            {
              wording: 'Adondevivir',
              link: 'https://www.adondevivir.com'
            }
          ]
        }
      ]
    }
  ],
  socialMedia: {
    title: 'Seguinos en',
    content: [
      {
        wording: 'Facebook',
        link: 'https://www.facebook.com/inmuebles24.com.mx',
        src: Facebook
      },
      {
        wording: 'Instagram',
        link: 'https://www.instagram.com/inmuebles24/',
        src: Instagram
      },
      {
        wording: 'Youtube',
        link: 'https://www.youtube.com/user/InmueblesTVRELA',
        src: Youtube
      },
      {
        wording: 'Twitter',
        link: 'https://twitter.com/inmuebles24',
        src: Twitter
      }
    ]
  },
  appsLinks: {
    title: 'Apps',
    content: [
      {
        wording: 'AppStore',
        link: 'https://apps.apple.com/mx/app/inmuebles24/id643973960',
        src: AppStore
      },
      {
        wording: 'GooglePlay',
        link: 'https://play.google.com/store/apps/details?id=com.navent.realestate.inmuebles24',
        src: GooglePlay
      }
    ]
  },
  legalLinks: {
    termsAndConditions: {
      url: 'https://help.inmuebles24.com/s/article/terminos-y-condiciones-de-uso-i24',
      wording: 'Términos y Condiciones de Uso',
      tag: null
    },
    termsAndConditionsHiring: {
      url:
        'https://help.inmuebles24.com/s/article/T%C3%A9rminos-y-Condiciones-Generales-de-Contrataci%C3%B3n-del-Portal-I24',
      wording: 'Términos y Condiciones de Contratación',
      tag: null
    },
    privacyPolicy: {
      url: 'https://help.inmuebles24.com/s/article/Aviso-de-Privacidad',
      wording: 'Política de privacidad',
      tag: null
    }
  },
  siteName: {
    name: 'inmuebles24.com'
  },
  logo: {
    src: ZonaLandingImgLOGO
  }
};

export { MXDataFooter };
